import { CommonModule } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { BackButtonIconComponent } from '@app/ui/back-button-icon/back-button-icon.component';

@Component({
  selector: 'sbnb-nested-full-screen-modal',
  standalone: true,
  imports: [BackButtonIconComponent, CommonModule],
  templateUrl: './nested-full-screen-modal.component.html',
  styleUrl: './nested-full-screen-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NestedFullScreenModalComponent implements AfterViewChecked {
  @Output() backIconClicked = new EventEmitter<void>();

  @ViewChild('projectedFooterContainer') projectedFooterContainer: ElementRef | undefined;

  cdr = inject(ChangeDetectorRef);
  elementRef = inject(ElementRef);

  hasFooterContent = true;

  ngAfterViewChecked() {
    this.hasFooterContent = this.projectedFooterContainer?.nativeElement?.children?.length > 0;
    this.cdr.detectChanges();
  }

  scrollToTop() {
    // Check all elements within the modal
    const modalElements = [
      this.elementRef.nativeElement,
      ...Array.from(this.elementRef.nativeElement.querySelectorAll('*')),
    ];

    // Also check parent elements up to the document body
    let parent = this.elementRef.nativeElement.parentElement;
    const parentElements = [];
    while (parent && parent !== document.body) {
      parentElements.push(parent);
      parent = parent.parentElement;
    }

    // Combine all elements to check
    const allElements = [...modalElements, ...parentElements];

    // Find the first scrollable element
    const scrollable = allElements.find((el) => {
      const style = window.getComputedStyle(el);
      return (style.overflowY === 'auto' || style.overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
    });

    if (scrollable) {
      scrollable.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Fallback to window scroll if no scrollable container found
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
